import Tooltip, { type TooltipProps } from '@mui/material/Tooltip'
import React from 'react'

import T from 'T'

type BillingLockedTooltipProps = Omit<TooltipProps, 'title' | 'children'> & {
  placement?: TooltipProps['placement']
  isLocked?: boolean
  children: React.ReactElement
}

const BillingLockedTooltip: React.FC<BillingLockedTooltipProps> = ({ placement = 'left', isLocked = false, children, ...rest }) => {
  if (!isLocked) {
    return children
  }

  return (
    <Tooltip arrow disableHoverListener={!isLocked} placement={placement} title={T.BILLING_LOCKED} {...rest}>
      <span>{children}</span>
    </Tooltip>
  )
}

export default BillingLockedTooltip
